module.exports = __webpack_public_path__ + "static/img/fixTop.080bc64.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/fixTop.png
// module id = 2NSJ
// module chunks = 18